import inviewAnim from "./modules/inview";
import { globalNav, accordion } from "./modules/libs";
import setTopAnim from "./modules/setTopAnim";
import setHeroAnim from "./modules/setHeroAnim";
// import setTextAnim from "./modules/setTextAnim";
import setChangeHeader from "./modules/setChangeHeader";
import setParallax from "./modules/setParallax";
// import setChangeBg from "./modules/setChangeBg";
import setGallerySlider from "./modules/setGallerySlider";
import setImgSlider from "./modules/setImgSlider";
import setHandingSlider from "./modules/setHandingSlider";


window.addEventListener('load', () => {
  inviewAnim();
  globalNav();
  accordion();
  setTopAnim();
  setHeroAnim();
  // setTextAnim();
  setChangeHeader();
  setParallax();
  // setChangeBg();
  setGallerySlider();
  setImgSlider();
  setHandingSlider();
})